// Chapters
export const CHAPTERS = 'chapters'

// COURSES
export const COURSES = 'courses'
export const USER_COURSES = 'user-courses'

// EPISODES
export const EPISODES = 'episodes'
export const EPISODE_BY_SLUG = (slug: string) => `episode-${slug}`

// EXPERIMENTS
export const experimentKey = (flagName: string) => ['flag', flagName]

// FEATURE INTERACTIONS
export const FEATURE_INTERACTIONS = 'feature-interactions'

// PROFILES
export const PROFILES = 'profiles'

// PLAYLISTS
export const PLAYLISTS = 'playlists'

// SESSIONS
export const SESSIONS = 'sessions'
export const USER_SESSIONS = 'user-sessions'

// SHOWCASES
export const SHOWCASES = 'showcases'

// SKILLS
export const SKILLS = 'skills'

// VIDEO PROGRESS
export const VIDEO_PROGRESS_ENTRIES = 'video-progress-entries'
export enum VIDEO_TYPE {
  IMMERSIVE_HEROS = 'immersive_heros',
}

// ONBOARDING CONTENT
export const ONBOARDING_CONTENT = 'onboarding-content'

// CERTIFICATE PROGRAM TILES
export const CERTIFICATE_PROGRAM_TILES = 'certificate_program_tiles'

// CERTIFICATE ENROLLMENTS
export const CERTIFICATE_ENROLLMENTS = 'certificate-enrollments'

// MY CERTIFICATE SUBSCRIPTION
export const MY_CERTIFICATE_SUBSCRIPTION = 'my-certificate-subscription'

// UNIQUE IDENTIFIERS
export const UNIQUE_IDENTIFIERS = 'unique-identifiers'
